var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { light: "", width: "800" },
      on: { input: _vm.closeDialog },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "pa-6", attrs: { light: "", cols: "12" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.isFormValid,
                callback: function ($$v) {
                  _vm.isFormValid = $$v
                },
                expression: "isFormValid",
              },
            },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12", md: "12" } }, [
                        _c("div", { staticClass: "mb-6 text-h5" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.modalTitle) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-0 mb-2" },
                    [
                      _c("v-col", { attrs: { cols: "12", md: "12" } }, [
                        _c("div", { staticClass: "form-dash-modal__rules" }, [
                          _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("AccessModal.label.important")) +
                                "\n              "
                            ),
                          ]),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("AccessModal.label.firstNote"))
                              ),
                            ]),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("AccessModal.label.secondNote"))
                              ),
                            ]),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("AccessModal.label.thirdNote"))
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rules: _vm.existsAndIsNumber,
                              "persistent-placeholder": _vm.isFormToEdit,
                              hint: _vm.displayAccHint
                                ? this.$t(
                                    "AccessModal.label.message.error.invalidInfo"
                                  )
                                : "",
                              "persistent-hint": false,
                              disabled: _vm.isFormToEdit,
                              label: _vm.$t(
                                "AccessModal.label.input.accountId"
                              ),
                            },
                            on: {
                              keyup: function ($event) {
                                return _vm.validateAccMaxLength()
                              },
                            },
                            model: {
                              value: _vm.accountId,
                              callback: function ($$v) {
                                _vm.accountId = $$v
                              },
                              expression: "accountId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rules: _vm.existsAndIsNumber,
                              hint: _vm.displayUniHint
                                ? this.$t(
                                    "AccessModal.label.message.error.invalidInfo"
                                  )
                                : "",
                              "persistent-placeholder": _vm.isFormToEdit,
                              disabled: _vm.isFormToEdit,
                              label: _vm.$t(
                                "AccessModal.label.input.universeId"
                              ),
                            },
                            on: {
                              keyup: function ($event) {
                                return _vm.validateUniMaxLength(_vm.universeId)
                              },
                            },
                            model: {
                              value: _vm.universeId,
                              callback: function ($$v) {
                                _vm.universeId = $$v
                              },
                              expression: "universeId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-0",
                          attrs: { cols: "12", md: "12" },
                        },
                        [
                          _c("v-combobox", {
                            attrs: {
                              outlined: "",
                              dense: !_vm.isThereFirstAccessUser,
                              disabled: !_vm.ableFirstAccessUserToEdit(),
                              rules: _vm.emailAccessRules,
                              items: [],
                              label: _vm.$t(
                                "AccessModal.label.input.usersAccess"
                              ),
                              hint: _vm.$t(
                                "AccessModal.label.message.hint.email"
                              ),
                              multiple: "",
                              "small-chips": "",
                              "deletable-chips": "",
                              "append-icon": "",
                              "search-input": _vm.newFirstAccess,
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.newFirstAccess = $event
                              },
                              "update:search-input": [
                                function ($event) {
                                  _vm.newFirstAccess = $event
                                },
                                _vm.splitFirstAccessUser,
                              ],
                            },
                            model: {
                              value: _vm.firstAccess,
                              callback: function ($$v) {
                                _vm.firstAccess = $$v
                              },
                              expression: "firstAccess",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          attrs: { cols: "12", md: "12" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "text-h6" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "AccessModal.label.title.environment"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    mandatory: "",
                                    disabled: _vm.isFormToEdit,
                                  },
                                  model: {
                                    value: _vm.environment,
                                    callback: function ($$v) {
                                      _vm.environment = $$v
                                    },
                                    expression: "environment",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    key: "production",
                                    attrs: {
                                      label: _vm.$t(
                                        "AccessModal.label.input.production"
                                      ),
                                      value: false,
                                    },
                                  }),
                                  _c("v-radio", {
                                    key: "staging",
                                    attrs: {
                                      label: _vm.$t(
                                        "AccessModal.label.input.staging"
                                      ),
                                      value: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          attrs: { cols: "12", md: "12" },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "text-h6" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "AccessModal.label.title.contractModel"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "py-0",
                                  attrs: { mandatory: "" },
                                  model: {
                                    value: _vm.contractModel,
                                    callback: function ($$v) {
                                      _vm.contractModel = $$v
                                    },
                                    expression: "contractModel",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    key: "contract",
                                    attrs: {
                                      label: _vm.$t(
                                        "AccessModal.label.input.contract"
                                      ),
                                      value: false,
                                    },
                                  }),
                                  _c("v-radio", {
                                    key: "trial",
                                    attrs: {
                                      label: _vm.$t(
                                        "AccessModal.label.input.trial"
                                      ),
                                      value: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
                        [
                          _vm.contractModel
                            ? _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": true,
                                    "nudge-right": 40,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      value:
                                                        _vm.computedDateFormatted,
                                                      label: _vm.$t(
                                                        "AccessModal.label.input.expirationDate"
                                                      ),
                                                      "prepend-icon":
                                                        "mdi-calendar",
                                                      readonly: "",
                                                      rules:
                                                        _vm.contractModelRules,
                                                    },
                                                  },
                                                  "v-text-field",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1603382208
                                  ),
                                },
                                [
                                  _c("v-date-picker", {
                                    model: {
                                      value: _vm.expiresTrialDate,
                                      callback: function ($$v) {
                                        _vm.expiresTrialDate = $$v
                                      },
                                      expression: "expiresTrialDate",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.isFormToEdit
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pt-4 py-0",
                              attrs: { cols: "12", md: "12" },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("div", { staticClass: "text-h6 mb-1" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "AccessModal.label.title.otherEditors"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _c("v-simple-table", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.mail"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.onboarding"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.otherEditors,
                                                  function (editor, key) {
                                                    return _c(
                                                      "tr",
                                                      { key: key },
                                                      [
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(editor.email)
                                                          ),
                                                        ]),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              editor
                                                                .onboardingStatus
                                                                .value
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      174466696
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.isFormToEdit
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pt-4 py-0",
                              attrs: { cols: "12", md: "12" },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("div", { staticClass: "text-h6 mb-1" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "AccessModal.label.title.lastUpdate"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _c("v-simple-table", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.user"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.mail"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.updatedDate"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dashboard.audit
                                                          .updatedBy
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dashboard.audit
                                                          .updatedByEmail
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.toDate(
                                                          _vm.dashboard.audit
                                                            .updatedDate
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2534995216
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.isFormToEdit
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-0",
                              attrs: { cols: "12", md: "12" },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("div", { staticClass: "text-h6 mb-1" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "AccessModal.label.title.createdDate"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _c("v-simple-table", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.user"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.mail"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass: "text-left",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "AccessModal.label.table.createdDate"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]),
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dashboard.audit
                                                          .createdBy
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dashboard.audit
                                                          .createdByEmail
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.toDate(
                                                          _vm.dashboard.audit
                                                            .createdDate
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2163582672
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { justify: "end", "no-gutters": "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-2",
                  attrs: {
                    rounded: "",
                    outlined: "",
                    color: "secondary",
                    loading: _vm.loadingBtn,
                    disabled: _vm.loadingBtn,
                  },
                  on: { click: _vm.closeDialog },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("AccessModal.label.button.cancel")) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    rounded: "",
                    color: "primary",
                    depressed: "",
                    loading: _vm.loadingBtn,
                    disabled: _vm.loadingBtn,
                  },
                  on: { click: _vm.validateForm },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.primaryButtonMessage) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }